import { NgModule } from '@angular/core';

import { DefaultImageDirective } from './image-directive';

@NgModule({
    declarations: [DefaultImageDirective],
    exports: [DefaultImageDirective]
})
export class DefaultImageDirectiveModule {}
